import React from "react";
import { Box, Paper, Grid } from "@mui/material";
import CommonTextEditor from "src/components/CommonTextEditor/CommonTextEditor";
import { CardItem } from "./CardItem";

interface Props {
  orderInfoData: any;
}

export const Card = ({ orderInfoData }: Props) => {
  const {
    address1,
    address2,
    category,
    location,
    ordNum,
    orderComment,
    orderStatus,
    orderType,
    poNum,
    priority,
    city,
    state,
    zip,
    company,
    clientCode,
    additionalInformation,
  } = orderInfoData;
  return (
    <>
      <Paper elevation={1} square>
        <Box p={2} mb={3}>
          <Grid container direction="row" xs={10} md={12}>
            <CardItem field="PO #" value={ordNum} />
            <CardItem field="Store Number" value={location} />
            <CardItem field="WO Status" value={orderStatus} />
            <CardItem field="Location Name" value={company} />
            <CardItem field="Category" value={category} />
            <CardItem field="Address 1" value={address1} />
            <CardItem field="Order Type" value={orderType} />
            <CardItem field="Address 2" value={address2} />
            <CardItem field="Priority" value={priority} />
            <CardItem field="City" value={city} />
            <CardItem field="Client Name" value={clientCode} />
            <CardItem field="State" value={state} />
            <CardItem field="Client PO #" value={poNum} />
            <CardItem field="Zip" value={zip} />
            {/* <CardItem field="Order Comment" value={orderComment} asHtml /> */}
          </Grid>
          <Grid direction="row" xs={12} md={12}>
            <Box mt={1}>
              <CommonTextEditor
                value={orderComment}
                name={"notes"}
                height={150}
                title="Scope of Work:"
                disabled
                showHeader
                noShowHeaderBorder
                customColor="rgba(0, 0, 0, 0.54)"
              />
            </Box>
          </Grid>
          <Grid direction="row" xs={12} md={12}>
            <Box mt={1}>
              <CommonTextEditor
                value={additionalInformation}
                name={"notes"}
                height={150}
                title="Additional Information:"
                disabled
                showHeader
                noShowHeaderBorder
                customColor="rgba(0, 0, 0, 0.54)"
              />
            </Box>
          </Grid>
        </Box>
      </Paper>
    </>
  );
};
